// extracted by mini-css-extract-plugin
export default {"revert_custom_loader":"revertLoader_revert_custom_loader__1dajy","s6":"revertLoader_s6__KLRcX"};